<template>
    <el-dialog :visible.sync="dialogVisible" top="4vh"  :show-close="false">
        <i class="el-icon-close" @click="dialogVisible=false"></i>
        <el-carousel trigger="click" height="100%" class="dialog-left" arrow="always" indicator-position="none" :autoplay="false" @change="itemChange">
            <el-carousel-item v-for="item in info.album" :key="item" >
                <div class="dialog-left__item" >
                    <img :src="item" >
                </div>
            </el-carousel-item>
            <span class="dialog-left__item--index" >{{ info.album.length?itemIndex:0 }}/{{ info.album.length }}</span>
        </el-carousel>
        <div class="dialog-right">
            <!-- <div class="dialog-right__type">大提琴家 / 大提琴家</div> -->

            <div class="dialog-right__name">{{info.content[$i18n.locale]?info.content[$i18n.locale].name:'--'}}</div>
             <div class="dialog-right__type">
                <span v-for="(tItem,index) in info.types" :key="index">{{ tItem[$i18n.locale]+ (info.types.length===(index+1)?' ':' / ') }}</span>
            </div>
           <div class="dialog-right__desc" v-html="info.content[$i18n.locale].desc"></div>
            <div class="dialog-right__scope">
                <img src="@/assets/images/scope_icon.png" >
                {{info.content[$i18n.locale].scope}}
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data(){
        return {
            dialogVisible:false,
            itemIndex:1,
            info:{
                content:{
                    CHN:{},
                    ENG:{}
                },
                types:[],
                album:[],

            }
        }
    },
    methods:{
        show(data){
            this.itemIndex=1;
            this.info=data
            this.dialogVisible=true;
        },  
        itemChange(val){
            this.itemIndex=val+1;
        },
        handleClose(){

        }
    },
    mounted(){
        console.log('aa')
    }
}
</script>

<style lang="less" scoped>
::v-deep .el-carousel__arrow--left{
    bottom: 20px;
    left:303px
}
::v-deep .el-carousel__arrow--right{
    bottom: 20px;
    right:303px
}
::v-deep .el-carousel__arrow{
    width: 40px;
    height: 40px;
    background-color: transparent;
    border: 1px solid #fff;
    top:auto;
    &>i{
        font-size: 20px;
    }
}
::v-deep .el-dialog{
    background: #02021C;
    width: 1864px;
    height: 90%;
    margin: 0 auto;
    border-radius: 80px;
    overflow: hidden;
    .el-dialog__header{
        display: none;
    }
    .el-dialog__body{
        display: flex;
        position: relative;
        padding: 0;
        color: #fff;
        font-size: 0;
        word-break: normal;
        height: 100%;
        width: 100%;
        .el-icon-close{
            cursor: pointer;
            position: absolute;
            right: 70px;
            top: 70px;
            color: #fff;
            font-size: 32px;
            border-radius: 80px;
        }
        .dialog-left{
            width: 815px;
            height: 100%;
            // align-items: center;
            .dialog-left__item{
                width: 100%;
                height: 100%;
                position: relative;
                display: flex;
                align-items: center;
                img{
                    width: 100%;
                    height: auto;
                }
                
            }
            .dialog-left__item--index{
                    position: absolute;
                    font-size:20px;
                    color:#fff;
                    bottom: 46px;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 2;
                }
        }
        .dialog-right{
            flex: 1;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            padding-top: 96px;
            padding-bottom: 68px;
            padding-left: 120px;
            .dialog-right__name{
                font-size: 42px;
                color: #FFFFFF;
                margin-block: 16px;
            }
            .dialog-right__type{
                font-size: 26px;
                color: rgba(255, 255, 255, 0.6);
            }
            .dialog-right__desc{
                font-size: 26px;
                color: #fff;
                flex: 1;
                overflow: auto;
                margin-top: 100px;
                margin-bottom: 100px;
                margin-right: 120px;
            }
            .dialog-right__scope{
                display: flex;
                align-items: center;
                font-size: 26px;
                color: rgba(255, 255, 255, 0.6);
                img{
                    margin-right: 14px;
                    width: 32px;
                    height: 32px;
                }
            }
        }
    }
}

@media screen and (max-width: 767px) {
    ::v-deep .el-dialog{
    background: #02021C;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    border-radius: 0;
    margin-top: 0 !important;
    overflow: hidden;
    .el-dialog__header{
        display: none;
    }
    .el-icon-close{
        font-size: 10vw !important;
        z-index: 4;


    }
    .el-dialog__body{
        display: flex;
        flex-direction: column;
        align-items: center;
        .el-carousel__arrow{
            width: 8vw;
            height: 8vw;
            i{
                font-size: 4vw;
            }
        }
        .el-carousel__arrow--left{
            bottom: 45%;
            left: 0;
        }
        .el-carousel__arrow--right{
            bottom: 45%;
            right: 0;
        }
        .dialog-left{
            width: 95%;
            height: 45%;
        }
        .dialog-right{
            width: 100%;
            padding-left: 6.25vw;
            padding-right: 6.25vw;
            display: flex;
            flex-direction: column;
            overflow: auto;
            .dialog-right__name{
                font-size: 6vw;
                height: 8.3333vw;
            }
            .dialog-right__type{
                font-size: 4vw;
                height: 5.3333vw;
            }
            .dialog-right__desc{
                font-size: 4vw;
                margin-right: 0;
                flex: 1;
                overflow: auto;
            }
            .dialog-right__scope{
                font-size: 4vw;
                height: 5.3333vw;
            }
        }
    }
}

}
</style>